import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import PropTypes from 'prop-types';
import './css/CollapsibleEventsTable.css';

const CollapsibleEventsTable = ({ events = [], formatCurrency }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleEventsSection = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <section className="top-events-section">
      <div className="top-events-header" onClick={toggleEventsSection}>
        <h3>Top Revenue Events</h3>
        <div className="collapse-toggle">
          <span>{isCollapsed ? 'Expand' : 'Collapse'}</span>
          <FaChevronDown className={`collapse-icon ${isCollapsed ? 'collapsed' : ''}`} />
        </div>
      </div>
      <div className={`events-table ${isCollapsed ? 'collapsed' : ''}`}>
        <table>
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Date</th>
              <th>Revenue</th>
              <th>Attendance</th>
              <th>% Contribution</th>
            </tr>
          </thead>
          <tbody>
            {events.length ? (
              events.map((event, index) => {
                const revenue = Number(event?.revenue ?? 0);
                const attendance = Number(event?.attendance ?? 0);

                return (
                  <tr key={index}>
                    <td className="event-name">
                      {event?.name ?? 'Unnamed Event'}
                    </td>
                    <td>{event?.date ?? '—'}</td>
                    <td>{formatCurrency(revenue)}</td>
                    <td>{attendance.toLocaleString()}</td>
                    <td>{Number(event?.percentage ?? 0)}%</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" className="empty-state">No revenue events to display yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

CollapsibleEventsTable.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      revenue: PropTypes.number,
      date: PropTypes.string,
      attendance: PropTypes.number,
      category: PropTypes.string,
      percentage: PropTypes.number,
    })
  ),
  formatCurrency: PropTypes.func.isRequired,
};

export default CollapsibleEventsTable;
